<template>
  <w-sliding-popup ref="slidingPopup" :title="popupParams.policyName" top="50px" width="600px" @close="close">
    <div slot="content">
      <el-row class="mr-b25">
        <div class="title-bar title-h4">룰 목록</div>
        <el-table-wrapper :data="policyDetailInfo" :columns="tableColumns" :column-default="columnDefault" :show-custom-header="false" :pagination="false" height="240px" @cell-click="onCellClick">
            <template slot-scope="scope" slot="slot">
              <span class="link">{{ scope.row.ruleName }}</span>
            </template>
        </el-table-wrapper>
      </el-row>
      <el-row class="mr-b25">
        <div class="title-bar title-h4">룰 상세내용</div>
        <el-input readonly resize="none" type="textarea" :rows="5" :value="currentRuleDetailInfo.ruleDescr" class="readonly-input-class"></el-input>
      </el-row>
      <el-row>
        <div class="title-bar title-h4">권장 스크립트</div>
        <span class="title-bar">스크립트 설명: 배너를 생성합니다.</span>
        <el-input readonly resize="none" type="textarea" :rows="10" :value="currentRuleDetailInfo.script" class="readonly-input-class"></el-input>
      </el-row>
    </div>
  </w-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { columnDefault } from '@/constants/table';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';

export default {
  name: 'WPolicyDetailInfoPopup',
  props: {
    popupParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      popupVisible: false,
      policyDetailInfo: [],
      currentRuleDetailInfo: { ruleDescr: null, script: null },
      columnDefault,
      tableColumns: [
        { prop: 'ruleId', label: '룰 ID', width: 80, sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ruleName', label: '룰 이름', scopedSlot: 'slot', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'severityName', label: '등급', width: 70, sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'templateName', label: '권장스크립트', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
      ],
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.currentRuleDetailInfo = { ruleDescr: null, script: null };
      this.loadData();
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 정책 상세 팝업 데이터 로드
     * @author jeee12
     */
    loadData() {
      this.$nextTick(() => {
        netdeviceInfoAPI.getNetdevicePolicyDetailInfo({
          policyId: this.popupParams.policyId,
        }).then((response) => {
          if (response.data.success) {
            this.policyDetailInfo = response.data.data;
          }
        });
      });
    },
    /**
     * 룰 목록 cell click, 룰 상세내용과 권장 스크립트 조회
     * @author jeee12
     * @param  {[type]} cell   해당 cell
     * @param  {[type]} column 해당 column
     */
    onCellClick(cell, column) {
      if (column.property === 'ruleName') {
        this.currentRuleDetailInfo.ruleDescr = !isEmpty(cell.ruleDescr) ? cell.ruleDescr : '';
        this.currentRuleDetailInfo.script = !isEmpty(cell.script) ? cell.script : '';
      }
    },
  },
};
</script>

<style module>
.readonly-input-class .el-textarea__inner {
  background: #f0f2f4;
}
</style>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/popup/PolicyDetailInfoPopup.vue